import { Box, Button } from '@wix/design-system';
import classNames from 'classnames';
import React, { useContext } from 'react';

import { RicosContext } from './../../../ricos-context';
import type { LogBiFn } from './../../../_shared/bi-context-provider/bi-context-provider';

import { CANCEL_BUTTON, SAVE_BUTTON } from './data-hooks';

type FooterActionsProps = {
  onCancel: () => void;
  onSave: () => void;
  logBi: LogBiFn;
  dataHook?: string;
  saveButtonLabel?: string;
};

export const FooterActions: React.FC<FooterActionsProps> = ({
  onCancel,
  onSave,
  logBi,
  dataHook,
  saveButtonLabel,
}) => {
  const { t } = useContext(RicosContext);

  return (
    <Box align="right" gap="SP2">
      <Button
        onClick={() => {
          logBi({ dataHook: classNames(CANCEL_BUTTON, dataHook) });
          onCancel();
        }}
        priority="secondary"
        dataHook={classNames(CANCEL_BUTTON, dataHook)}
        size="small"
      >
        {t('SettingsPanelFooter_Cancel')}
      </Button>
      <Button
        onClick={() => {
          logBi({ dataHook: classNames(SAVE_BUTTON, dataHook) });
          onSave();
        }}
        priority="primary"
        dataHook={classNames(SAVE_BUTTON, dataHook)}
        size="small"
      >
        {saveButtonLabel ?? t('SettingsPanelFooter_Save')}
      </Button>
    </Box>
  );
};
